module.exports = __webpack_public_path__ + "static/Francesca_Mazziotti-68af229b95431a2798fde23949b7c54e.jpg";